module.exports = __webpack_public_path__ + "src/assets/games/23/494.jpg";